import { PanelClass } from '@mairistem/finances-utils';
import React from 'react';
import ImpactEnvironnementComponent from '@/src/components/Panel/ImpactEnvironnementComponent';
import type { Projet } from '@/src/interfaces/projet';

class ImpactEnvironnementPanel extends PanelClass {
	constructor(isMandatory: boolean) {
		super(isMandatory);
		this.code = 'ENV';
		this.icon = {
			name: 'tree',
		};
	}

	getLibelle = () => "Impact sur l'environnement";

	isEmpty = (data: Projet) =>
		!data?.impactEnvironnement && !data?.impactEnvironnementTexte;

	getComponent = function getComponent(
		data: any,
		onChange: any,
		handlePin: any,
	): React.ReactElement {
		return (
			<ImpactEnvironnementComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default ImpactEnvironnementPanel;
